export enum Link {
  consultCurp = 'https://www.gob.mx/curp/',
}
